import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTrophy, FaUsers, FaCalendarCheck, FaMedal, FaArrowRight } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const AdvancedTraining = () => {

    return (
        <>
            <Helmet>
                <title>Advanced Training</title>
            </Helmet>
            <div className="about-page">
                <div className="page-header">
                    <div className="container">
                        <h1>Advanced Training</h1>
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <span>Advanced Training</span>
                        </div>
                    </div>
                </div>

                <section className="about-intro section">
                    <div className="container">
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <span className="section-subtitle">Imperial Badminton Academy</span>
                                <h2>Advanced Training Program</h2>
                                <p>
                                    The Advanced Training Program at Imperial Badminton Academy is designed for highly committed players who aim to compete at district, state, national, or professional levels. This program focuses on elite skill refinement, tactical mastery, peak physical conditioning, and mental resilience required for high-performance badminton.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="intro-img-main">
                                    <img src="/img/Advanced Training.jpg" alt="Academy Training" />
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Who Should Join the Advanced Program?</h3>
                                <p>
                                    Competitive and tournament-level players
                                    <br></br>
                                    State or district-level athletes
                                    <br></br>
                                    Intermediate players ready for high-intensity training
                                    <br></br>
                                    Players aspiring to professional badminton careers
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Core Areas of Advanced Training</h3>
                                    <p>Powerful and deceptive smash variations
                                        <br></br>
                                        Advanced net play and tight net control
                                        <br></br>
                                        Defensive techniques and counter-attacks
                                        <br></br>
                                        Precision placement and shot disguise
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Tactical & Strategic Gameplay</h3>
                                <p>
                                    Analyze opponents and exploit weaknesses
                                    <br></br>
                                    Build rallies intelligently
                                    <br></br>
                                    Control match tempo
                                    <br></br>
                                    Adapt strategies mid-match
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Speed, Agility & Explosive Power</h3>
                                    <p>High-intensity agility drills
                                        <br></br>
                                        Speed endurance sessions
                                        <br></br>
                                        Plyometric and power training
                                        <br></br>
                                        Recovery and mobility exercises</p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Professional Fitness & Conditioning</h3>
                                <p>
                                    Strength development
                                    <br></br>
                                    Cardiovascular endurance
                                    <br></br>
                                    Core stability
                                    <br></br>
                                    Injury prevention and rehabilitation
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Match Simulation & Competitive Practice</h3>
                                    <p>Match temperament
                                        <br></br>
                                        Pressure handling
                                        <br></br>
                                        Decision-making under stress
                                        <br></br>
                                        Competitive confidence</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Mental Conditioning & Focus Training</h3>
                                    <p>Concentration and focus techniques
                                        <br></br>
                                        Stress and pressure management
                                        <br></br>
                                        Goal setting and performance mindset
                                        <br></br>
                                        Confidence building</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Performance Analysis & Feedback</h3>
                                    <p>Advanced players receive continuous performance evaluation through coach feedback, match reviews, and progress tracking. Individual improvement plans are designed to address specific performance goals.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Tournament Preparation & Exposure</h3>
                                    <p>District, state, and national tournaments
                                        <br></br>
                                        Ranking events
                                        <br></br>
                                        Professional-level competitions
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Benefits of Advanced Training at Imperial Badminton Academy</h3>
                                    <p>Elite-level skill development
                                        <br></br>
                                        Professional match preparation
                                        <br></br>
                                        Improved mental toughness
                                        <br></br>
                                        Peak physical conditioning
                                        <br></br>
                                        Pathway to competitive success
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Your Path to Excellence</h3>
                                    <p>The Advanced Training Program is designed for players who are ready to challenge themselves and compete at the highest levels. At Imperial Badminton Academy, we provide the guidance, discipline, and environment needed to transform dedicated athletes into confident competitors.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AdvancedTraining
    ;
